import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import { StatusType } from 'commons/types';
import { hasMetaplansAction, SubscriptionsSelector } from '../../redux';

interface Attributes {
  status: StatusType;
  hasMetaplans: boolean;
  fetchHasMetaplans: () => void;
}

export function useHasMetaplans(): Attributes {
  const dispatch = useAppDispatch();
  const hasMetaplans = useSelector(SubscriptionsSelector.hasMetaplans);
  const status = useSelector(SubscriptionsSelector.hasMetaplansStatus);

  const fetchHasMetaplans = useCallback(() => {
    dispatch(hasMetaplansAction());
  }, [dispatch]);

  return {
    status,
    hasMetaplans: hasMetaplans,
    fetchHasMetaplans: fetchHasMetaplans,
  };
}
